import { createApi } from '@core/fetch'

export default {
  getCustomerList: createApi(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/PushCustomerList'
  ),
  getList: createApi('/p/wedding/Admin/APIPotentialCustomer/List'),
  getInfo: createApi('/p/wedding/Admin/APIPotentialCustomer/MerchantInfo'),
  pushCustomer: createApi.post(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/PushCustomer'
  ),
  getPushList: createApi(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/PushList'
  ),
  delPush: createApi.post(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/delete'
  ),
  getPushDetail: createApi(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/PushDetail'
  ),
  getCount: createApi(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/ListStatusCount'
  ),
  getActionList: createApi(
    '/p/wedding/index.php/Admin/APIPotentialCustomer/ActionList',
    {
      expect: []
    }
  )
}
